import axios from "axios";

export default {
  methods: {
    async checkEmail() {
      let email = this.email;
      if (!email) {
        return;
      }
      try {
        await axios.get("/api/auth/check_email", {
          params: { email: email, redir: sessionStorage.redir },
        });
      } catch (e) {
        if (!e.response) {
          console.error(e);
          return;
        }
        if (email === this.email) {
          if (
            e.response.data.error &&
            e.response.data.error.type === "RequireSSOAuth"
          ) {
            this.errors = this.$t("message.require-sso", [
              this.currentEdition.name,
              e.response.data.error.url,
            ]);
          }
        }
      }
    },
  },
};
